export default {"src":"/_next/static/media/helpdesk-systems.924b7840.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};